import { useRoutes } from 'react-router-dom';

// routes
import MainRoutes from './MainRoutes';
import AuthenticationRoutes from './AuthenticationRoutes';
import config from 'config';

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
    const route = [];
    const MainRoutesData = MainRoutes();
    // console.log(MainRoutesData);
    if (localStorage.getItem('token')) {
        // console.log(MainRoutes());
        route.push(MainRoutesData);
    } else {
        route.push(AuthenticationRoutes);
    }
    return useRoutes(route, config.basename);
}
